export const equipmentinfoOption = {
  height: 'auto',
  calcHeight: 'auto',
  tip: false,
  border: true,
  index: true,
  indexLabel: '序号',
  viewBtn: true,
  selection: true,

  labelWidth: 140,
  group: [
    {
      label: '设备',
      prop: 'jbxx',
      icon: 'el-icon-edit-outline',
      arrow: false,
      column: [
        {
          label: '所属小区',
          prop: 'areaId',
          type: 'tree',
          dataType: 'string',
          dicUrl: 'api/base/property/treeChildrenPowerNode',
          props: { label: 'objectFullName', value: 'id' },
          rules: [
            {
              required: true,
              message: '请选择所属小区',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '设备码',
          prop: 'equipmentCode',
          maxlength: 30,
          showWordLimit: true,
          rules: [
            {
              required: true,
              message: '请输入设备码',
              trigger: 'blur',
            },
          ],
          search: true,
          searchPlaceholder: '模糊匹配设备码',
        },
        {
          label: '设备名',
          prop: 'equipmentName',
          maxlength: 30,
          showWordLimit: true,
          rules: [
            {
              required: true,
              message: '请输入设备名',
              trigger: 'blur',
            },
          ],
          search: true,
          searchPlaceholder: '模糊匹配设备名',
        },
        {
          label: '设备类别',
          prop: 'type',
          rules: [
            {
              required: true,
              message: '请输入设备类别',
              trigger: 'blur',
            },
          ],
          dicData: [
            {
              label: '给排水设备',
              value: 1,
            },
            {
              label: '电器设备',
              value: 2,
            },
            {
              label: '供暖通风设备',
              value: 3,
            },
            {
              label: '燃气设备',
              value: 4,
            },
          ],
          type: 'select',
          search: true,
        },
        {
          label: '设备价格',
          prop: 'price',
          maxlength: 10,
          showWordLimit: true,
          rules: [
            {
              pattern: /(^0$)|(^[1-9](\d+)?(\.\d{1,2})?$)|(^[1-9]$)|(^\d\.[1-9]{1,2}$)|(^\d\.[0]{1}[1-9]{1}$|(^\d\.[1-9]{1}[0]{1}$)$)/,
              message: '请输入正确的数字，最多精确到小数点后2位',
            },
            {
              message: '请输入设备价格',
              required: true,
              trigger: 'blur',
            },
          ],
        },
      ],
    },
    {
      label: '时间',
      prop: 'jbxx',
      icon: 'el-icon-edit-outline',
      arrow: false,
      column: [
        {
          label: '开始使用时间',
          row: true,
          span: 16,
          prop: 'beginUseTime',
          rules: [
            {
              required: true,
              message: '请选择开始使用时间',
              trigger: 'blur',
            },
          ],
          format: 'yyyy-MM-dd HH:mm:ss',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          type: 'datetime',
        },
        {
          label: '维护保养周期(天)',
          row: true,
          span: 16,
          prop: 'maintainingIntervals',
          maxlength: 4,
          showWordLimit: true,
          rules: [
            { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入正整数' },
            {
              required: true,
              message: '请输入维护保养周期(天)',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '上次维护保养时间',
          row: true,
          span: 16,
          prop: 'lastMaintainingTime',
          rules: [
            {
              required: true,
              message: '请选择上次维护保养时间',
              trigger: 'blur',
            },
          ],
          format: 'yyyy-MM-dd HH:mm:ss',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          type: 'datetime',
        },
        {
          label: '设备状态',
          row: true,
          span: 16,
          prop: 'equipmentStatus',
          rules: [
            {
              required: true,
              message: '请选择设备状态',
              trigger: 'blur',
            },
          ],
          dataType: 'number',
          props: {
            label: 'dictValue',
            value: 'dictKey',
          },
          dicUrl: '/api/blade-system/dict/dictionary?code=equipment_status',
          clearable: true,
          type: 'select',
          search: true,
        },
      ],
    },
  ],
  column: [
    {
      label: '设备码',
      prop: 'equipmentCode',
      addDisplay: false,
      editDisplay: false,
      addDetail: true,
      viewDisplay: false,
      rules: [
        {
          required: true,
          message: '请输入设备码',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '设备名',
      addDisplay: false,
      editDisplay: false,
      addDetail: true,
      viewDisplay: false,
      prop: 'equipmentName',
      rules: [
        {
          required: true,
          message: '请输入设备名',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '设备类别',
      addDisplay: false,
      editDisplay: false,
      addDetail: true,
      viewDisplay: false,
      prop: 'type',
      rules: [
        {
          required: true,
          message: '请输入设备类别',
          trigger: 'blur',
        },
      ],
      dicData: [
        {
          label: '给排水设备',
          value: 1,
        },
        {
          label: '电器设备',
          value: 2,
        },
        {
          label: '供暖通风设备',
          value: 3,
        },
        {
          label: '燃气设备',
          value: 4,
        },
      ],
      type: 'select',
    },
    {
      label: '设备价格',
      addDisplay: false,
      editDisplay: false,
      addDetail: true,
      viewDisplay: false,
      prop: 'price',
      rules: [
        {
          required: true,
          message: '请输入设备价格',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '所属小区',
      addDisplay: false,
      editDisplay: false,
      addDetail: true,
      viewDisplay: false,
      prop: 'areaId',
      rules: [
        {
          required: true,
          message: '请选择所属小区',
          trigger: 'blur',
        },
      ],
      props: {
        label: 'objectFullName',
        addDisplay: false,
        editDisplay: false,
        addDetail: true,
        value: 'id',
      },
      type: 'tree',
      dataType: 'string',
      dicUrl: 'api/base/property/treeChildrenPowerNode',
    },
    {
      label: '开始使用时间',
      addDisplay: false,
      editDisplay: false,
      addDetail: true,
      viewDisplay: false,
      prop: 'beginUseTime',
      rules: [
        {
          required: true,
          message: '请选择开始使用时间',
          trigger: 'blur',
        },
      ],
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
      type: 'datetime',
    },
    {
      label: '维护保养周期(天)',
      addDisplay: false,
      editDisplay: false,
      addDetail: true,
      viewDisplay: false,
      prop: 'maintainingIntervals',
      rules: [
        {
          required: true,
          message: '请输入维护保养周期(天)',
          trigger: 'blur',
        },
      ],
      type: 'number',
    },
    {
      label: '上次维护保养时间',
      addDisplay: false,
      editDisplay: false,
      addDetail: true,
      viewDisplay: false,
      prop: 'lastMaintainingTime',
      rules: [
        {
          required: true,
          message: '请选择上次维护保养时间',
          trigger: 'blur',
        },
      ],
      format: 'yyyy-MM-dd ',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
      type: 'datetime',
    },
    {
      label: '设备状态',
      addDisplay: false,
      editDisplay: false,
      addDetail: true,
      viewDisplay: false,
      prop: 'equipmentStatus',
      rules: [
        {
          required: true,
          message: '请选择设备状态',
          trigger: 'blur',
        },
      ],
      dataType: 'number',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dicUrl: '/api/blade-system/dict/dictionary?code=equipment_status',
      clearable: true,
      type: 'select',
    },
  ],
};
